import {TextInput} from '@mantine/core';

TextInput.displayName = 'TextInput';

export {TextInput, type TextInputFactory, type TextInputProps} from '@mantine/core';
